<div class="projectable-form-wrapper"
  (keyup.enter)="save($event)"
  (keyup.escape)="closeModal(false)"
  [class.projectable-form-hidden]="!dataInit"
  >
  <lib-form-header
    [data]="formData"
    [title]="formData.id ? 'Edit Service Edge Router Policy: ' : 'Create New Service Edge Router Policy'"
    [moreActions]="moreActions"
    [multiActions]="multiActions"
    (actionRequested)="headerActionRequested($event)"
    (multiActionRequested)="multiActionRequested($event)"
    [(formView)]="formView"
    [class.is-scrolled]="isScrolled"
    [saveDisabled]="formPermissionSaveDisabled"
    [saveTooltip]="formPermissionSaveTooltip"
    [strictReadonlyUi]="useStrictReadonlyForm"
  ></lib-form-header>
  <div class="service-edge-router-policy-form-container projectable-form-container" #formContainer>
    @if (formView === 'simple') {
      <div class="projectable-form-main-column form-group-row">
        <div class="form-group-column three-fifths">
          <lib-form-field-container [title]="'Service Edge Router Policy Name'" [label]="useStrictReadonlyForm ? '' : 'REQUIRED'">
              <input
                class="form-field-input"
                placeholder="Name this service edge router policy"
                [ngClass]="{error: errors['name']}"
                [(ngModel)]="formData.name"
                autofocus
                #nameFieldInput
                [disabled]="useStrictReadonlyForm"
                />
          </lib-form-field-container>
          <lib-form-field-container
            [title]="'Select Edge Router Attributes'"
            [label]="'OPTIONAL'"
            [contentStyle]="'z-index: 100003'"
            [helpText]="'Choose which edge router to associate to this policy by picking from the list of available attributes'"
            >
            <lib-tag-selector
              [disableField]="useStrictReadonlyForm"
              [disableCreate]="useStrictReadonlyForm"
              [(selectedRoleAttributes)]="selectedEdgeRouterRoleAttributes"
              [(selectedNamedAttributes)]="selectedEdgeRouterNamedAttributes"
              [availableRoleAttributes]="svc.edgeRouterRoleAttributes"
              [availableNamedAttributes]="svc.edgeRouterNamedAttributes"
              (selectedNamedAttributesChange)="svc.getAssociatedEdgeRoutersByAttribute(selectedEdgeRouterRoleAttributes, selectedEdgeRouterNamedAttributes, formData.semantic)"
              (selectedRoleAttributesChange)="svc.getAssociatedEdgeRoutersByAttribute(selectedEdgeRouterRoleAttributes, selectedEdgeRouterNamedAttributes, formData.semantic)"
              (filterChange)="getEdgeRouterNamedAttributesDebounced($event)"
              [namedAttributesServerFiltered]="true"
              [placeholder]="'Select edge router attributes'"
            ></lib-tag-selector>
          </lib-form-field-container>
          <lib-form-field-container
            [title]="'Select Service Attributes'"
            [label]="'OPTIONAL'"
            [contentStyle]="'z-index: 100002'"
            [helpText]="'Choose which services to associate to this policy by picking from the list of available attributes'"
            >
            <lib-tag-selector
              [disableField]="useStrictReadonlyForm"
              [disableCreate]="useStrictReadonlyForm"
              [(selectedRoleAttributes)]="selectedServiceRoleAttributes"
              [(selectedNamedAttributes)]="selectedServiceNamedAttributes"
              [availableRoleAttributes]="svc.serviceRoleAttributes"
              [availableNamedAttributes]="svc.serviceNamedAttributes"
              (selectedNamedAttributesChange)="svc.getAssociatedServicesByAttribute(selectedServiceRoleAttributes, selectedServiceNamedAttributes, formData.semantic)"
              (selectedRoleAttributesChange)="svc.getAssociatedServicesByAttribute(selectedServiceRoleAttributes, selectedServiceNamedAttributes, formData.semantic)"
              (filterChange)="getServiceNamedAttributesDebounced($event)"
              [namedAttributesServerFiltered]="true"
              [placeholder]="'Select service attributes'"
            ></lib-tag-selector>
          </lib-form-field-container>
          <lib-form-field-container
            [title]="'Semantic'"
            [layout]="'row'"
            >
            <select
              [(ngModel)]="formData.semantic"
              (change)="updateAssociations()"
              id="PolicySemantic"
              class="form-field-dropdown"
              [disabled]="useStrictReadonlyForm"
              >
              <option value="AnyOf">AnyOf</option>
              <option value="AllOf">AllOf</option>
            </select>
          </lib-form-field-container>
          <lib-form-field-toggle [(toggleOn)]="showMore" (toggleOnChange)="showMoreChanged($event)" style="margin: 0px 10px"></lib-form-field-toggle>
          <div [hidden]="!showMore" class="form-group-column">
            @if (!hideTags) {
              <lib-form-field-container
                [title]="'Custom Tags'"
                [label]="'OPTIONAL'"
                class="form-field-advanced"
                >
                <lib-custom-tags [(tags)]="formData.tags" [readOnly]="useStrictReadonlyForm"></lib-custom-tags>
              </lib-form-field-container>
            }
          </div>
        </div>
        <div class="form-group-column two-fifths">
          <lib-form-field-container
            [title]="'Associated Edge Routers'"
            [count]="svc.associatedEdgeRouterNames.length"
            [class]="'hide-overflow'"
            [helpText]="'Preview list of all Edge Routers that this Service Edge Router Policy is associated with.'"
            >
            <lib-preview-list
              [clickable]="false"
              [isLoading]="edgeRoutersLoading"
              [allNames]="svc.associatedEdgeRouterNames"
            ></lib-preview-list>
          </lib-form-field-container>
          <lib-form-field-container
            [title]="'Associated Services'"
            [count]="svc.associatedServiceNames.length"
            [helpText]="'Preview list of all Services that this Service Edge Router Policy is associated with.'"
            >
            <lib-preview-list
              [clickable]="false"
              [isLoading]="servicesLoading"
              [allNames]="svc.associatedServiceNames"
            ></lib-preview-list>
          </lib-form-field-container>
          @if (showApiCalls) {
            <lib-form-field-container
              [title]="'API Calls'"
              [headerActions]="apiOptions"
              (actionRequested)="apiActionRequested($event)"
              >
              <div class="form-row">
                <input class="form-field-input" [value]="apiCallURL"/>
                <div class="icon-copy copy-text" (click)="copyToClipboard(apiCallURL)"></div>
              </div>
              @if (formData) {
                <lib-json-view [(data)]="apiData" [readOnly]="true" [showCopy]="true"></lib-json-view>
              }
            </lib-form-field-container>
          }
        </div>
      </div>
    }
    @if (formView === 'raw') {
      <div class="form-group-column">
        @if (formData) {
          <lib-json-view [(data)]="formData" [readOnly]="useStrictReadonlyForm"></lib-json-view>
        }
      </div>
    }
  </div>
</div>
@if (isLoading || !dataInit) {
  <lib-loading-indicator [isLoading]="isLoading || !dataInit"></lib-loading-indicator>
}
